import { useEffect, useState, useCallback } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import $ from "jquery";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
import autoTable from "jspdf-autotable";
import { Link } from "react-router-dom";
import DashboardLayout from "../../common/DashboardLayout";
import AdminServices from "../AdminServices";
import InfluencerServices from "../InfluencerServices";
import "../../assets/css/custom.css"; // Adjust the path if needed
import "./styles.css";
import requests, { setToken } from "../../../services/httpServices";

const InfluenceList = () => {
  const [influencers, setInfluencers] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showAddingInfluencerPage, setShowAddingInfluencerPage] =
    useState(false);

  const [newUser, setNewUser] = useState({
    name: "",
    email: "",
    type: "Influencer",
    reemcode: "",
    cardNumber: "",
    rate: 0,
  });

  const fetchInfluences = useCallback(async () => {
    try {
      const response = await AdminServices.getAllInfluences({
        page: currentPage,
        search,
      });
      console.log("getAllInfluences: ", response);
      setInfluencers(response.influencers || []);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      console.error("Error fetching influences:", error);
    }
  }, [currentPage, search]);

  useEffect(() => {
    fetchInfluences();
  }, [fetchInfluences]);

  useEffect(() => {
    if (influencers.length === 0) return; // Prevent initializing if no data

    if ($.fn.DataTable.isDataTable("#influencersTable")) {
      $("#influencersTable").DataTable().destroy(); // Destroy old instance before reinitializing
    }

    $("#influencersTable").DataTable({
      responsive: true,
      autoWidth: false,
      paging: true, // ✅ Enable Pagination
      searching: true,
      ordering: true,
      pageLength: 10, // ✅ Set default entries per page
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"],
      ], // ✅ Add pagination options
    });

    $('#influencersTable').closest('.dt-layout-table').addClass('dt-custom-table');
  }, [influencers]); // ✅ Re-run only when `schools` updates

  const exportPDF = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Influence's Data Report";
    const headers = [
      ["NAME", "Email", "Rate", "Total Sales Amount", "Total Earning Amount"],
    ];

    const data = influencers.map((elt) => [
      elt.name,
      elt.email,
      elt.rate + `%`,
      `$` + elt.totalSalesAmount,
      `$` + elt.totalEarningAmount,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    autoTable(doc, {
      startY: 50,
      head: headers,
      body: data,
    });
    doc.save("report.pdf");
  };

  const handleAddingInfluencer = async () => {
    try {
      const requestBody = {
        name: newUser.name,
        email: newUser.email,
        type: newUser.type,
        reemcode: newUser.reemcode,
        cardNumber: newUser.cardNumber,
        rate: newUser.rate,
      };

      const result = await InfluencerServices.addInfluencer(requestBody);

      if (result.success) {
        setInfluencers((prev) => [...prev, result.data]);
        setShowAddingInfluencerPage(false);
      }
    } catch (error) {
      console.log("Fail Clear");
    }
  };

  const onClickClearButton = async (influencerId) => {
    try {
      const result = await InfluencerServices.clearInfluencerAmount(
        influencerId
      );

      const index = influencers.findIndex((f) => f._id === result._id);
      const influencerArray = [...influencers];

      influencerArray[index] = { ...result };

      setInfluencers([...influencerArray]);
    } catch (error) {
      console.log("Fail Clear");
    }
  };

  const onClickDeleteButton = async (influencerId) => {
    try {
      const result = await InfluencerServices.removeInfluencer(influencerId);

      setInfluencers((prev) => prev.filter((f) => f._id !== result._id));
    } catch (error) {
      console.log("Fail Clear");
    }
  };

  return (
    <DashboardLayout 
      role="admin" 
      layoutType="topnav"
      activeMenu="Influencers List"
      showBreadcrumbs={false}
    >
      <div className="col-xl-12 col-lg-12">
              {/* <div className="dashboard-title">
                  <h4>Influencer List</h4>
                  <button
                    className="dashboard-addButton"
                    onClick={() => setShowAddingInfluencerPage(true)}
                  >
                    Add Influencer
                  </button>
                </div> */}

              {/* Table with DataTables */}
              <div className="row">
                <div
                  key={influencers.map((i) => i._id).join("-")}
                  className="custom-table"
                >
                  <table
                    id="influencersTable"
                    className="table table-nowrap mb-0"
                  >
                    <thead>
                      <tr>
                        <th></th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Email</th>
                        <th>rate</th>
                        <th>Promo Code</th>
                        <th>Total Sales Amount</th>
                        <th>Total Earning Amount</th>
                        <th>Clear</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {influencers.map((influencer, index) => (
                        <tr key={influencer._id}>
                          <td>{index + 1}</td>
                          <td>{influencer.name}</td>
                          <td>{influencer.type}</td>
                          <td>{influencer.email}</td>
                          <td>{influencer.rate}%</td>
                          <td>{influencer.reemcode}</td>
                          <td>${influencer.totalSalesAmount}</td>
                          <td>${influencer.totalEarningAmount}</td>
                          <td
                            className="edit-rate"
                            onClick={() => onClickClearButton(influencer._id)}
                          >
                            Clear
                          </td>
                          <td
                            className="edit-rate"
                            onClick={() =>
                              onClickDeleteButton(influencer._id)
                            }
                          >
                            Delete
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div>
                  <button className="content-button" onClick={exportPDF}>
                    Download
                  </button>
                  <button
                    className="dashboard-addButton"
                    onClick={() => setShowAddingInfluencerPage(true)}
                  >
                    Add Influencer
                  </button>
                </div>
              </div>
      </div>
      {showAddingInfluencerPage && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="influencerPage">
            <div className="add-influencer-modal">
              <div className="influencerPage__item">
                <p>Name</p>
                <input
                  className="influencerPage__input"
                  type="text"
                  placeholder="John Doe"
                  onChange={(e) =>
                    setNewUser((prevState) => ({
                      ...prevState,
                      name: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="influencerPage__item">
                <p>Email</p>
                <input
                  className="influencerPage__input"
                  type="email"
                  placeholder="abc@gmail.com"
                  onChange={(e) =>
                    setNewUser((prevState) => ({
                      ...prevState,
                      email: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="influencerPage__item">
                <p>Type</p>
                <select
                  value={newUser.type}
                  defaultValue="Influencer"
                  onChange={(e) =>
                    setNewUser((prevState) => ({
                      ...prevState,
                      type: e.target.value,
                    }))
                  }
                >
                  <option value="Influencer">Influencer</option>
                  <option value="Salesperson">Salesperson</option>
                </select>
              </div>
              <div className="influencerPage__item">
                <p>Redeem Code</p>
                <input
                  className="influencerPage__input"
                  type="text"
                  placeholder="***"
                  onChange={(e) =>
                    setNewUser((prevState) => ({
                      ...prevState,
                      reemcode: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <div className="influencerPage__item">
                <p>Card Number</p>
                <input
                  className="influencerPage__input"
                  type="text"
                  placeholder="1234567890"
                  onChange={(e) =>
                    setNewUser((prevState) => ({
                      ...prevState,
                      cardNumber: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <div className="influencerPage__item">
                <p>Rate</p>
                <input
                  className="influencerPage__input"
                  type="Number"
                  placeholder="10"
                  onChange={(e) =>
                    setNewUser((prevState) => ({
                      ...prevState,
                      rate: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <div className="inluencerPage__buttonPair">
                <button
                  className="influencerPage__button"
                  onClick={() => setShowAddingInfluencerPage(false)}
                >
                  Cancel
                </button>
                <button
                  className="influencerPage__button"
                  onClick={handleAddingInfluencer}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};

export default InfluenceList;
